module.exports = __webpack_public_path__ + "static/img/beian.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/beian.png
// module id = df1F
// module chunks = 1